import { Gallery, GalleryCard, GalleryCardProps, PillWithTooltipProps } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

export interface GalleryCardAttributes extends Omit<GalleryCardProps, 'image' | 'pills'> {
  image: {
    id: number
    url: string
  }
}

export interface IAttributes {
  title: React.ReactNode
  background: 'white' | 'blue'
  cards: GalleryCardAttributes[]
  pills: PillWithTooltipProps[]
  withPills: boolean
}

export const DEFAULT_PILLS: GalleryCardProps['pills'] = [
  { text: 'Android', icon: 'android', iconSide: 'right' },
  { text: 'Windows', icon: 'windows', iconSide: 'right' },
  { text: 'iOS', icon: 'apple', iconSide: 'right' },
  { text: 'MACOS', icon: 'macos', iconSide: 'right' },
  { text: 'Linux', icon: 'docker', iconSide: 'right' },
]

const GallerySectionBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <Gallery
      title={attributes.title}
      background={attributes.background}
      pills={attributes.withPills ? DEFAULT_PILLS : attributes?.pills}
    >
      {attributes.cards.map((card, index) => (
        <GalleryCard key={index} {...card} image={card?.image?.url ? <Image src={card?.image?.url} /> : null} />
      ))}
    </Gallery>
  )
}

const Image = styled.img`
  height: auto;
  max-width: 100%;
`

export default GallerySectionBlock
